/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as R404RouteImport } from './routes/404'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ScheduledDateServiceNameRouteImport } from './routes/$scheduledDate/$serviceName'

const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduledDateServiceNameRoute =
  ScheduledDateServiceNameRouteImport.update({
    id: '/$scheduledDate/$serviceName',
    path: '/$scheduledDate/$serviceName',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/$scheduledDate/$serviceName': typeof ScheduledDateServiceNameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/$scheduledDate/$serviceName': typeof ScheduledDateServiceNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/$scheduledDate/$serviceName': typeof ScheduledDateServiceNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$' | '/404' | '/$scheduledDate/$serviceName'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$' | '/404' | '/$scheduledDate/$serviceName'
  id: '__root__' | '/' | '/$' | '/404' | '/$scheduledDate/$serviceName'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  R404Route: typeof R404Route
  ScheduledDateServiceNameRoute: typeof ScheduledDateServiceNameRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$scheduledDate/$serviceName': {
      id: '/$scheduledDate/$serviceName'
      path: '/$scheduledDate/$serviceName'
      fullPath: '/$scheduledDate/$serviceName'
      preLoaderRoute: typeof ScheduledDateServiceNameRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  R404Route: R404Route,
  ScheduledDateServiceNameRoute: ScheduledDateServiceNameRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
